module.exports = __webpack_public_path__ + "media/images/flags/1x1/bdi-92fc95a4f3c00f62cf65c170ffb86014.svg";